import { render, staticRenderFns } from "./ResumenEjecutivo.vue?vue&type=template&id=1b385dea"
import script from "./ResumenEjecutivo.vue?vue&type=script&lang=js"
export * from "./ResumenEjecutivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports